import { EditorFieldsItem } from './EditorFieldsItem'
import React, { useEffect, useState } from 'react'
import { emptyFormFieldDTO, FormFieldDTO } from '../../modules/forms/models/FormDTO'
import { Box, Button, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

type FormFieldListProps = {
  formFields: FormFieldDTO[]
  handlerChange: (formFields: FormFieldDTO[]) => void
}

export function EditorFields(props: FormFieldListProps) {
  const { t } = useTranslation()

  const [formFields, setFormFields] = useState<FormFieldDTO[]>([])

  useEffect(() => {
    setFormFields(props.formFields)
  }, [props.formFields])

  // El diseno enseña ya una pregunta lista para rellenar: un cuestionario sin
  // ninguna no se puede guardar, asi que empezar en blanco solo obliga a
  // buscar el boton antes de poder escribir nada.
  useEffect(() => {
    if (props.formFields.length === 0) {
      setFormFields((f) => (f.length === 0 ? [emptyFormFieldDTO(1)] : f))
    }
  }, [props.formFields])

  const addFormField = () => {
    const nextOrder = formFields.length > 0 ? Math.max(...formFields.map((f) => f.order)) + 1 : 1
    setFormFields([...formFields, emptyFormFieldDTO(nextOrder)])
  }

  function handleFormFieldChange(formField: FormFieldDTO) {
    const index = formFields.findIndex((ff) => ff.id === formField.id)
    if (index > -1) {
      const result = [...formFields]
      result.splice(index, 1, formField)
      setFormFields(result)
    }
  }

  const handleFormFieldRemove = (id: string) => {
    setFormFields(formFields.filter((f) => f.id !== id))
  }

  useEffect(() => {
    props.handlerChange(formFields)
  }, [formFields])

  return (
    <>
      <Typography sx={{ fontSize: '15px', fontWeight: 600, color: 'var(--gray-medium)', mb: 2 }}>
        {t('questionnaireFields')}
      </Typography>
      {formFields.map((f: FormFieldDTO) => (
        <Box key={f.id} my={3}>
          <EditorFieldsItem
            handleChange={handleFormFieldChange}
            handleRemove={handleFormFieldRemove}
            formField={f}
          />
        </Box>
      ))}
      <Box display="flex" alignItems="center" mt={3}>
        <Button
          type="button"
          startIcon={<AddIcon />}
          onClick={addFormField}
          sx={{
            textTransform: 'none',
            borderRadius: '999px',
            border: '1px solid var(--gray-border)',
            color: 'var(--gray-text)',
            px: 2,
          }}
        >
          {t('addQuestion')}
        </Button>
      </Box>
    </>
  )
}
